export default __webpack_public_path__ + "static/chalkboard-equation-8470fddbd423a05015c812cc0bd24a37.jpg";